import { useSelector } from 'react-redux'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { RootState } from '../redux/store'
import { usePermissions } from '../hooks/usePermissions'

function ProtectedRoute() {
    const user = useSelector((store:RootState) => store.auth.token)
    const location = useLocation();
    const { canAccessPath } = usePermissions();
    if (!user) {
        return <Navigate to={"/signin"} replace />
    }
    if (!canAccessPath(location.pathname)) {
        return <Navigate to="/unauthorized" replace />
    }
    return <Outlet />
}

export default ProtectedRoute